import { CloudCommand } from "../types.js";

export const getMyEvents: CloudCommand = {
    action: "EVENTS/GET_MY_EVENTS",
    commandName: "events.getMyEvents",
    buildPayload: ({ start }) => ({ start }),
};
